// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1098":"8a8a157c","2201":"8a8a157c","5201":"8a8a157c","5586":"8a8a157c","6527":"8a8a157c","8585":"24b05fda"}[chunkId] + ".chunk.css";
};